import Contact from "../../views/contact/Contact";
import "./style.css";

export default function ContactPage(params) {
  return (
    <div className="contactPage container">
      <div className="main">
        <Contact />
      </div>
    </div>
  );
}
